import React from 'react';

interface CRMSkeletonProps {
  type?: 'opportunities' | 'pipelines';
  isMobile?: boolean;
}

export function CRMSkeleton({ type = 'opportunities', isMobile = false }: CRMSkeletonProps) {
  if (type === 'pipelines') {
    return (
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden animate-pulse">
        <div className="overflow-hidden">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Pipeline Name
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Array.from({ length: 3 }).map((_, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                      <div className="flex-1">
                        <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                        <div className="h-3 bg-gray-100 rounded w-20"></div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                      <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
                      <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Opportunities Kanban skeleton
  return (
    <div 
      className="flex space-x-4 sm:space-x-6 pb-4 overflow-x-auto"
      style={{
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(156, 163, 175, 0.2) transparent',
      }}
    >
      {Array.from({ length: 4 }).map((_, stageIndex) => (
        <div
          key={stageIndex}
          className="flex-shrink-0 w-80 bg-gray-50/50 backdrop-blur-sm border border-gray-200/60 rounded-2xl p-4 animate-pulse"
        >
          {/* Stage Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex-1">
              <div className="h-5 bg-gray-200 rounded w-24 mb-2"></div>
              <div className="h-3 bg-gray-100 rounded w-32"></div>
            </div>
            <div className="w-4 h-4 bg-gray-200 rounded"></div>
          </div>
          
          {/* Opportunity Cards */}
          <div className="space-y-3">
            {Array.from({ length: 3 }).map((_, cardIndex) => (
              <div
                key={cardIndex}
                className="bg-white border border-gray-200/60 rounded-xl p-4"
              >
                {/* Title and action */}
                <div className="flex items-start justify-between mb-3">
                  <div className="h-4 bg-gray-200 rounded w-32 flex-1"></div>
                  <div className="w-16 h-6 bg-gray-200 rounded-lg ml-2"></div>
                </div>
                
                {/* Value */}
                <div className="h-6 bg-gray-200 rounded w-20 mb-3"></div>
                
                {/* Customer info */}
                <div className="pt-3 border-t border-gray-100/80">
                  <div className="flex items-center gap-2.5">
                    <div className="w-7 h-7 bg-gray-200 rounded-full"></div>
                    <div className="flex-1">
                      <div className="h-3 bg-gray-200 rounded w-24 mb-1"></div>
                      <div className="h-2 bg-gray-100 rounded w-32"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
